var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalTrainer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0a4 4 0 100 8 4 4 0 000-8zm-2 4a2 2 0 114 0 2 2 0 01-4 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10a.996.996 0 00-.63.224L3.09 13.646a2 2 0 00-.414 2.672l1.49 2.237a1 1 0 101.665-1.11l-1.491-2.237L7 13.08V23a1 1 0 102 0V12h6v11a1 1 0 102 0v-9.92l2.659 2.128-1.491 2.237a1 1 0 101.664 1.11l1.49-2.237a2 2 0 00-.413-2.672l-4.278-3.422A.996.996 0 0016 10H8z"
  })));
}
export default SvgPersonalTrainer;